import { tss } from 'tss-react';

export const useStyles = tss.create({
  editorMenuContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  }
});

export const sx = {
  loading: {
    color: 'white',
    marginRight: 1
  },
  menu: {
    marginBottom: 1
  }
};
